export default __webpack_public_path__ + "static/article-what-is-involved-in-getting-a-car-loan-2bbacb71b6339c4fac6d77509b54522c.jpg";